import router from '@/router'
import { KeyDict } from '@/types'
import { computed, ComputedRef } from '@vue/composition-api'

export const getUrl = (name: string, params?: KeyDict<any>): string => {
  const route = router.resolve({ name, params })
  return route.href
}

const useRouter = () => {
  const currentRouteName = computed(() => router.currentRoute.name)
  const isBreakoutMode: ComputedRef<boolean> = computed(() => currentRouteName.value === 'liveEventBreakout')

  return {
    isBreakoutMode,
    getUrl
  }
}

export default useRouter
